const NUMBER_DATA = {

1:{
    title:"Career",
    short:"Leader",
    characteristic:"Independent, confident, ambitious and self-motivated.",
    prediction:"Leadership roles and business opportunities suit you well.",
    missing:"You may struggle with confidence, communication and taking initiative.",
    planet:"Sun",
    element:"Water",
    direction:"North",
    colors:"Black, Dark Blue",
    body:"Kidneys, Ears",
    bracelet:{
   
    productHandle:"golden-sunstone-bracelet-joy-leadership-and-positive-energy"
},
},

2:{
    title:"Relationships",
    short:"Harmony",
    characteristic:"Sensitive, caring, cooperative and emotional.",
    prediction:"Strong relationships and teamwork bring success.",
    missing:"You may find it difficult to express emotions or maintain relationships.",
    planet:"Moon",
    element:"Earth",
    direction:"South-West",
    colors:"White, Pink",
    body:"Abdomen",
    bracelet:{
    
    productHandle:"rose-quartz-bracelet-love-compassion-and-emotional-healing"
},

},

3:{
    title:"Health",
    short:"Creativity",
    characteristic:"Creative, expressive, imaginative and optimistic.",
    prediction:"Creative work and communication bring happiness.",
    missing:"You may struggle with creativity and expressing yourself.",
    planet:"Jupiter",
    element:"Wood",
    direction:"East",
    colors:"Green",
    body:"Feet",
    bracelet:{
    
    productHandle:"yellow-aventurine-bracelet-confidence-creativity-and-optimism"
},
},

4:{
    title:"Luck",
    short:"Discipline",
    characteristic:"Organized, disciplined, practical and reliable.",
    prediction:"Hard work always rewards you.",
    missing:"Planning and discipline may require extra effort.",
    planet:"Rahu",
    element:"Wood",
    direction:"South-East",
    colors:"Purple, Green",
    body:"Liver",
    bracelet:{
    
    productHandle:"hematite-bracelet-grounding-stability-and-focus"
},
},

5:{
    title:"Balance",
    short:"Freedom",
    characteristic:"Flexible, adventurous and adaptable.",
    prediction:"You thrive when embracing change.",
    missing:"You may resist change and feel stuck in routines.",
    planet:"Mercury",
    element:"Earth",
    direction:"Center",
    colors:"Yellow",
    body:"Internal Organs",
    bracelet:{
    
    productHandle:"green-tiger-eye-bracelet-confidence-balance-and-prosperity"
},
    
},

6:{
    title:"Friends",
    short:"Responsibility",
    characteristic:"Responsible, caring and family-oriented.",
    prediction:"You become the support system for many people.",
    missing:"Building long-term friendships may require conscious effort.",
    planet:"Venus",
    element:"Metal",
    direction:"North-West",
    colors:"White, Grey",
    body:"Head",
    gemstone:"Diamond / White Zircon",
    bracelet:{
    
    productHandle:"moonstone-bracelet-emotional-balance-intuition-and-new-beginnings"
},
},

7:{
    title:"Wisdom",
    short:"Spiritual",
    characteristic:"Thoughtful, intuitive, analytical and spiritual.",
    prediction:"Knowledge and spirituality guide your life.",
    missing:"You may overlook inner growth or intuition.",
    planet:"Ketu",
    element:"Metal",
    direction:"West",
    colors:"Silver, White",
    body:"Lungs",
    bracelet:{
    
    productHandle:"lapis-lazuli-heated-bracelet-wisdom-communication-and-confidence"
},
    
},

8:{
    title:"Knowledge",
    short:"Success",
    characteristic:"Organized, ambitious and financially focused.",
    prediction:"Persistence leads to wealth and recognition.",
    missing:"Motivation and long-term planning may need improvement.",
    planet:"Saturn",
    element:"Earth",
    direction:"North-East",
    colors:"Blue, Black",
    body:"Hands",
    bracelet:{
    
    productHandle:"pyrite-bracelet-wealth-success-and-protection"
},
},

9:{
    title:"Prosperity",
    short:"Humanity",
    characteristic:"Compassionate, generous and humanitarian.",
    prediction:"Helping others brings fulfillment.",
    missing:"You may struggle to connect emotionally or contribute to larger causes.",
    planet:"Mars",
    element:"Fire",
    direction:"South",
    colors:"Red",
    body:"Heart",
    bracelet:{
    
    productHandle:"red-carnelian-bracelet-motivation-courage-and-creativity"
},
}

};

const ARROWS=[

{
numbers:[4,9,2],
name:"Memory",
description:"Excellent memory and learning ability."
},

{
numbers:[3,5,7],
name:"Spirituality",
description:"Strong spiritual awareness and intuition."
},

{
numbers:[8,1,6],
name:"Practicality",
description:"Excellent business sense and practical thinking."
},

{
numbers:[2,5,8],
name:"Emotional Balance",
description:"Balanced emotions and patience."
},

{
numbers:[4,5,6],
name:"Will Power",
description:"Confidence and determination."
},

{
numbers:[2,7,6],
name:"Action",
description:"Energetic and action-oriented personality."
},

{
numbers:[4,3,8],
name:"Planning",
description:"Excellent planner and organizer."
},

{
numbers:[9,5,1],
name:"Determination",
description:"Strong determination and focus."
}

];